"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _RecommendationSummaryParser = require("../generic/RecommendationSummaryParser");
var _constants = require("../../constants");
var _services = require("../../../services");
/**
 * Parser for generating recommendation summary values specific to Chile.
 * Extends the base RecommendationSummaryParser class.
 */
class ChileRecommendationSummaryParser extends _RecommendationSummaryParser.RecommendationSummaryParser {
  constructor(props) {
    super(props);
  }

  /**
   * Calculates the number of columns based on the total term cost and total upfront cost.
   * @returns The number of columns.
   */
  calculateColumns() {
    return 3;
  }

  /**
   * Gets the plan name  for the recommendation summary section.
   * @returns plan name as string.
   */
  getPlanName(product) {
    var _product$productName;
    const planHeader = this.isPlanIdWithDifferentHeader ? _services.Services.locale.localeString('Recommendation.OtherPlanName') : _services.Services.locale.localeString('Recommendation.PlanName');
    const planName = this.showFullPlanName ? product === null || product === void 0 ? void 0 : product.productName : product === null || product === void 0 ? void 0 : (_product$productName = product.productName) === null || _product$productName === void 0 ? void 0 : _product$productName.split('Plan')[1].trim();
    return planHeader + ' ' + planName;
  }

  /**
   * Returns the product default memory value.
   * @param product - The SummaryProduct object.
   * @returns The product memory text.
   */
  getDefaultMemoryValue(product) {
    var _product$memory, _product$memory$value, _product$memory2;
    const memory = product === null || product === void 0 ? void 0 : (_product$memory = product.memory) === null || _product$memory === void 0 ? void 0 : (_product$memory$value = _product$memory.value) === null || _product$memory$value === void 0 ? void 0 : _product$memory$value.find(v => v.isDefault);
    return memory ? `${memory.value} ${memory.unitOfMeasure || 'GB'}` : product === null || product === void 0 ? void 0 : (_product$memory2 = product.memory) === null || _product$memory2 === void 0 ? void 0 : _product$memory2.valueText;
  }

  /**
   * Returns the product cost subtext based on a given product object.
   * @param product - The SummaryProduct object.
   * @returns The product cost subtext.
   */
  productCostSubText(product) {
    let handsetProductCostSubText = `${_services.Services.locale.localeString('Recommendation.upTo')} ${product.termDuration} ${_services.Services.locale.localeString('Recommendation.installments')}`;
    let planProductCostSubText = _services.Services.locale.localeString('Recommendation.pricePerMonth', {
      amount: product.termDuration,
      unit: _services.Services.locale.localeString('Recommendation.month'),
      price: _services.Services.locale.formatPrice(product.termCost),
      pluralUnit: _services.Services.locale.localeString('Recommendation.Month')
    });
    if (this.journeyType && this.journeyType === _constants.FLAGS.BOTH_FLOW) {
      var _handsetProductCostSu, _planProductCostSubTe;
      handsetProductCostSubText = `${product.termDuration} ${_services.Services.locale.localeString('Recommendation.installments')} ${_services.Services.locale.localeString('Recommendation.from')} 
    ${_services.Services.locale.formatPrice(product.termCost)}/${_services.Services.locale.localeString('Recommendation.month')}`;
      handsetProductCostSubText = (_handsetProductCostSu = handsetProductCostSubText) === null || _handsetProductCostSu === void 0 ? void 0 : _handsetProductCostSu.toLocaleLowerCase();
      planProductCostSubText = (_planProductCostSubTe = planProductCostSubText) === null || _planProductCostSubTe === void 0 ? void 0 : _planProductCostSubTe.toLocaleLowerCase();
    }
    return product.productType === _constants.PRODUCT_TYPES.HANDSET ? handsetProductCostSubText : product.termCostAfterDiscount && product.termCostAfterDiscount !== product.termCost && planProductCostSubText;
  }
}
var _default = ChileRecommendationSummaryParser;
exports.default = _default;